"use client";

import { THEME_SETTING } from "@/setting/setting";
import Image from "next/image";
import { cloudflareLoader, replaceDomain } from "../../core-nextv3/util/util";
import React from "react";

interface ImageSetProps {
  src?: string;
  image?: {
    name: string;
    id: string;
    type: string;
    _url: string;
    _150x150: string;
    _300x300: string;
    _480x480: string;
    _1024x1024: string;
    _1920x1920: string;
  };
  width?: number;
  height?: number;
  aspectRatio?: number;
  className?: string;
  enabledGif?: boolean;
  domainFrom?: string;
  domainTo?: string;
  alt?: string;
  sizes?: string;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  priority?: boolean;
  responsive?: boolean;
  style?: React.CSSProperties;
  objectFit?: React.CSSProperties["objectFit"];
}

export const ImageSet = ({
    src,
    image,
    width = 1920,
    height = 400,
    sizes = "",
    enabledGif = false,
    alt = "",
    priority = false,
    responsive = true,
    className = "",
    onClick,
    style = {},
    objectFit,
}: ImageSetProps) => 
{
    const placeholder = "/assets/product_placeholder.png";

    const imageLoader = (): string => 
    {
        if (src) return src;

        const url = encodeURI(image?._url || "") || placeholder;

        // if (!THEME_SETTING.imageCDN) 
        // {
        //     if (enabledGif && url.toLowerCase().endsWith(".gif")) return url;

        //     // if (width <= 480 && (image?._480x480 || image?._300x300)) 
        //     // {
        //     //     url = encodeURI(image?._480x480 || image?._300x300 || "");
        //     // }
        //     // else if (width <= 1024 && image?._1024x1024) 
        //     // {
        //     //     url = encodeURI(image?._1024x1024);
        //     // }
        //     // else if (width <= 1920 && image?._1920x1920) 
        //     // {
        //     //     url = encodeURI(image?._1920x1920);
        //     // }

        //     url = url.replace(".webp", ".jpeg");

        //     url += url.includes("?") ? "&auto=format" : "?auto=format";

        //     if (THEME_SETTING.domainFrom && THEME_SETTING.domainTo) 
        //     {
        //         url = replaceDomain(url, THEME_SETTING.domainFrom, THEME_SETTING.domainTo);
        //     }
        // }

        return url;
    };

    const getStyle = (): React.CSSProperties => 
    {
        if (responsive) 
        {
            return {
                width     : "100%",
                height    : "auto",
                objectFit : objectFit || "cover",
                ...style,
            };
        }

        return { ...style };
    };

    const finalSrc = imageLoader();

    const isSvg = finalSrc.toLowerCase().endsWith(".svg");

    const loadingMode: "eager" | "lazy" = priority ? "eager" : "lazy";

    // Se for SVG, usa <img> normal
    if (isSvg) 
    {
        return (
            <img
                src={finalSrc}
                alt={alt}
                width={width}
                height={height}
                className={className}
                onClick={onClick}
                style={getStyle()}
                loading={loadingMode}
                fetchPriority={priority ? "high" : "auto"}
            />
        );
    }

    // Se for imagem padrão (não SVG)
    return THEME_SETTING.imageCDN ? (
        <Image
            className={className}
            onClick={onClick}
            loader={cloudflareLoader}
            src={finalSrc}
            sizes={sizes || `${width}px`}
            width={width}
            height={height}
            alt={alt}
            priority={priority}
            fetchPriority={priority ? "high" : "auto"}
            loading={loadingMode}
            //blurDataURL={image?._url || src}
            style={getStyle()}
        />
    ) : (
        <Image
            loader={() => finalSrc}
            src={placeholder}
            onClick={onClick}
            className={className}
            sizes={sizes || `${width}px`}
            width={width}
            height={height}
            alt={alt}
            priority={priority}
            fetchPriority={priority ? "high" : "auto"}
            loading={loadingMode}
            style={getStyle()}
        />
    );
};